<script setup>
import DataFilterPopup from './DataFilterPopup.vue'
import { useDataFilter } from '~/core/composables/useDataFilter'

const props = defineProps(['filter'])

const { t } = useI18n()
const { filter } = toRefs(props)
const { label, isLabelNoun } = useDataFilter(filter)

const isOpen = ref(false)
</script>

<template>
  <DataFilterPopup
    :filter="filter"
    placement="bottom"
    :offset="4"
    @open="isOpen = true"
    @close="isOpen = false"
  >
    <button
      class="h-40px w-full flex flex-row cursor-default items-center justify-between flex-gap-x-2 rounded bg-white px-4 py-2 text-left shadow-none ring-1 ring-surface-700 ring-inset lt-sm:text-sm"
      :class="[isOpen ? 'ring-secondary' : 'ring-surface-700']"
    >
      <span>{{ isLabelNoun ? `${t('Any')} ` : '' }}{{ label }}</span>
      <DSIcon
        size="24"
        icon="i-far-chevron-down"
      />
    </button>
  </DataFilterPopup>
</template>

<i18n>
{
  "en-us": {
    "Any": "Any"
  }
}
</i18n>

<i18n locale="de" lang="json">
{
  "Any": "Jede"
}
</i18n>

<i18n locale="fr" lang="json">
{
  "Any": "Tous"
}
</i18n>

<i18n locale="es" lang="json">
{
  "Any": "Cualquiera"
}
</i18n>
